export default __webpack_public_path__ + "static/media/362.580d8940.png";